import React, { useCallback, useState } from 'react';
import { endServiceByUniqueIdentifier } from '../../core/_requests';
import { APIError, useAxios } from '../../core/_axios';
import { Service } from '../../core/_models';
import { Link, useNavigate } from 'react-router-dom';

export default function EndServiceForm({
    service,
    onSetService,
}: {
    service: Service,
    onSetService: (service: Service) => void
}) {
    const axios = useAxios();

    const navigate = useNavigate();

    const [endingService, setEndingService] = useState(false);
    const [errorEndingService, setErrorEndingService] = useState<string | null>(null);

    const onEndService = useCallback(async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (endingService) {
            return;
        }
        setErrorEndingService(null);
        setEndingService(true);
        try {
            const resultingService = await endServiceByUniqueIdentifier(axios, service.unique_identifier);
            // Go immediately to the service details page
            navigate(`/services/${resultingService.unique_identifier}/details`);
            onSetService(resultingService);
        } catch (exception) {
            console.error(exception)
            const errorMessage = exception instanceof APIError ? exception.message : 'An unknown error has occurred. Please try again.'
            setErrorEndingService(errorMessage)
            setEndingService(false)
        }
    }, [axios, endingService, navigate, onSetService, service.unique_identifier]);

    if (!service.is_active) {
        return (
            <div className="container-fixed">
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
                    <span className="block sm:inline">
                        This service is not active and cannot be ended.
                    </span>
                </div>
                <div className="mt-5">
                    <Link
                        to={`/services/${service.unique_identifier}/details`}
                        className="btn btn-lg btn-light"
                    >
                        Manage Service
                    </Link>
                </div>
            </div>
        );
    }

    return <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 lg:gap-7.5">
        <div className="col-span-2">
            <div className="flex flex-col gap-5 lg:gap-7.5">
                <form className="card" onSubmit={onEndService}>
                    <div className="card-header">
                        <h3 className="card-title">
                            End Service
                        </h3>
                    </div>
                    <div className="card-body grid gap-7.5 py-5 lg:py-7.5">
                        <div>
                            <p>
                                Are you sure you want to end this service?
                            </p>
                        </div>
                    </div>
                    <div className="card-footer py-3.5 flex flex-col lg:flex-row items-center justify-between">
                        <div>
                            {errorEndingService && <div className="text-red-500 text-sm font-medium">{errorEndingService}</div>}
                        </div>
                        <div>
                            <Link
                                to={`/services/${service.unique_identifier}/details`}
                                className="btn btn-sm btn-light me-2"
                            >
                                Cancel
                            </Link>
                            <button
                                type="submit"
                                className="btn btn-sm btn-danger"
                                disabled={endingService}
                            >
                                {!endingService ? `End Service` : `Ending Service...`}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
}